import { Link } from "react-router-dom";

const ProviderNameLinkField = ({ firstName, lastName, id }) => {
  return (
    <Link to={`/Provider/${id}/show`} target="_blank">
      <span>{`${firstName} ${lastName}`}</span>
    </Link>
  );
};

export default ProviderNameLinkField;
